import { useEffect } from "react";

const BASE = "https://tuttimieilink.com";

interface CanonicalUrlProps {
  path: string;
}

const CanonicalUrl = ({ path }: CanonicalUrlProps) => {
  const url = `${BASE}${path}`;

  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;

    return () => {
      link?.remove();
    };
  }, [url]);

  return null;
};

export default CanonicalUrl;
